import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment'
import MaterialTable  from '@material-table/core';
import { TableIcons } from '../../../../constants/tableIcons';
import { firestore } from '../../../../firebase/firebase'
import TicketOptions from '../../../components/Reports/TicketReport/TicketOptions';
import { Paper, IconButton } from '@material-ui/core';
import ReportSelect from '../../../components/Reports/ReportSelect'
import { makeStyles, useMediaQuery } from '@material-ui/core';
import _ from 'lodash'
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Skeleton } from '@material-ui/lab';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { useCustomer } from '../../../../providers/CustomerContext';
import { useUser } from '../../../../providers/UserContext';
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';
import { withRouter } from 'react-router-dom';
import { useAuth } from '../../../../providers/AuthContext';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: '32px',
        paddingRight: '230px',
        overflow: 'auto'
    },
    sidebar: {
        position: 'fixed',
        right: 0,
        top: '64px',
        maxWidth: '256px',
        width: '100%',
        padding: '16px',
        minHeight: '100vh',
        zIndex: '1000',
    },
    expand: {
        position: 'fixed',
        right: 0,
        top: '444px',
        transform: 'rotate(90deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        position: 'fixed',
        right: 253,
        top: '444px',
        transform: 'rotate(270deg)',
    },
}));

const TicketReport = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { customers, getCustomers } = useCustomer();
    const { getUsers, usersLoading, users } = useUser();
    const { userSettings } = useAuth();
    const darkMode = !_.isUndefined(userSettings['colorMode']) ? userSettings['colorMode'] : 'light';
    const tableRef = useRef(MaterialTable);

    const [startDate, setStartDate] = useState("startDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("startDate"))) : moment());
    const [endDate, setEndDate] = useState("endDate" in sessionStorage ? moment(JSON.parse(sessionStorage.getItem("endDate"))) : moment());
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [searchBarValue, setSearchBarValue] = useState("ticketSearchBarValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("ticketSearchBarValue")) : null)
    const [expanded, setExpanded] = useState(JSON.parse(sessionStorage.getItem("reportExpanded")) || true);

    const [searchUsers, setSearchUsers] = useState([])
    const [filteredTicketData, setFilteredTicketData] = useState([])

    //gets initial data
    useEffect(() => {
        getCustomers();
        getUsers();
        //eslint-disable-next-line
    }, []);

    //live filter
    useEffect(() => {
        if (!props.ticketData) return;
        let ticketContainer = _.cloneDeep(props.ticketData)

        //check for displayNames in searchUsers
        if(searchUsers.length > 0){ ticketContainer = ticketContainer.filter(data => searchUsers.includes(data.displayName)) }

        setFilteredTicketData(ticketContainer);
    // eslint-disable-next-line
    }, [props.ticketData, searchUsers]);

    const startDateHandler = date => {
        setStartDate(date)
        sessionStorage.setItem("startDate", JSON.stringify(date))
    }
    const endDateHandler = date => {
        setEndDate(date)
        sessionStorage.setItem("endDate", JSON.stringify(date))
    }

    const handleExpandClick = () => {
        if(expanded)
            setExpanded(false);
        else
            setExpanded(true);
        sessionStorage.setItem("reportExpanded", JSON.stringify(expanded))
    };

    const generateHandler = () => {
        setErrorMessage(null);
        setLoading(true);

        firestore.collection('ticketEntries')
        .where("date", ">=", startDate.startOf('day').format('YYYY-MM-DD'))
        .where("date", "<=", endDate.endOf('day').format('YYYY-MM-DD'))
        .get().then(querySnapshot => {
            let ticketResponse = querySnapshot.docs.map((doc) => {
                return {
                    ...doc.data(),
                    'docId': doc.id,
                    'displayName': users.find(x=> x.uuid === doc.data().uid)?.displayName || '',
                }
            })

            props.updateTableCache('ticketReport', {ticketData: ticketResponse})
            setLoading(false);

        }).catch(e => {
            setLoading(false);
            setErrorMessage(`Unable to process due to: ${e.message}`);
            console.log(e.message);
            props.updateTableCache('ticketReport', {ticketData: []})
        });
    }

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    const handlePrintTicketReport = () => {
        props.history.push({
            pathname: '/dashboard/reporting/tickets/printing/report/',
            state: { data: tableRef?.current?.state?.data, startDate: moment(startDate).format('YYYY-MM-DD'), endDate: moment(endDate).format('YYYY-MM-DD')}
        })
    }

    return (
        <React.Fragment>
            <div className={classes.content}
            style={expanded ? {paddingRight: '260px' } : {paddingRight: smallScreen ? '12px' : '230px' }} >
                {loading === false ?
                <MaterialTable
                    tableRef={tableRef}
                    columns={[
                        { title: 'Ticket Number', field: 'ticket' },
                        { title: 'Date', field: 'date',
                            render: rowData => {
                                return moment(rowData.date).format('YYYY-MM-DD')
                            },
                            exportTransformer: (rowData) => {
                                return (rowData.date !== '' ? moment(rowData.date).format('YYYY-MM-DD') : '')
                            },
                            customFilterAndSearch: (term, rowData) => {
                                return (moment(rowData.date).format('YYYY-MM-DD').indexOf(term) !== -1)
                            },
                        },
                        {   title: 'Customer', field: 'customerId',
                            render: rowData => {
                                let customerName = customers.find(x=> x.docId === rowData.customerId)?.name
                                return !_.isUndefined(customerName) ? customerName : ''
                            },
                            exportTransformer: (rowData) => {
                                let customerName = customers.find(x=> x.docId === rowData.customerId)?.name
                                return (!_.isUndefined(customerName) ? customerName : '')
                            },
                            customSort: (a, b) => {
                                let aContainer = customers.find(x=> x.docId === a.customerId)?.name
                                let bContainer = customers.find(x=> x.docId === b.customerId)?.name
                                return ( aContainer.toLowerCase() > bContainer.toLowerCase() ? 1 : -1)
                            },
                            customFilterAndSearch: (term, rowData) => {
                                return (customers.find(x=> x.docId === rowData.customerId)?.name.toLowerCase().indexOf(term) !== -1)
                            },
                        },
                        { title: 'Employee', field: 'displayName',},
                        { title: 'Invoice Pay Date', field: 'invoicePayDate',
                            render: rowData => {
                                return rowData.invoicePayDate === null ? '' : moment(rowData.invoicePayDate).format('YYYY-MM-DD')
                            },
                            exportTransformer: (rowData) => {
                                return (rowData.invoicePayDate !== '' ? moment(rowData.invoicePayDate).format('YYYY-MM-DD') : '')
                            },
                            customFilterAndSearch: (term, rowData) => {
                                return (moment(rowData.invoicePayDate).format('YYYY-MM-DD').indexOf(term) !== -1)
                            },
                        },
                        { title: 'Source', field: 'sourceCollection',
                            render: rowData => {
                                return capitalizeFirstLetter(rowData.sourceCollection)
                            },
                        },
                        { title: 'Payroll', field: 'payroll',
                            customSort: (a, b) => {
                                let aContainer = Number(a.payroll)
                                let bContainer = Number(b.payroll)
                                return ( aContainer > bContainer ? 1 : -1)
                            },
                        },
                        { title: 'Cartage Total', field: 'cartageSalesTotal',
                            customSort: (a, b) => {
                                let aContainer = Number(a.cartageSalesTotal)
                                let bContainer = Number(b.cartageSalesTotal)
                                return ( aContainer > bContainer ? 1 : -1)
                            },
                        },
                    ]}
                    data={filteredTicketData}
                    title='Ticket Reports'
                    icons={TableIcons}
                    isLoading={loading}
                    onSearchChange={ (value) => {setSearchBarValue(value);  sessionStorage.setItem("ticketSearchBarValue", JSON.stringify(value))}}
                    onRowsPerPageChange={(num) => {sessionStorage.setItem("ticketReportRowsPerPage", JSON.parse(num))}}
                    actions={[
                        {
                            icon: TableIcons.OpenInNew,
                            tooltip: 'View Ticket Report',
                            onClick: (event, rowData) => { props.ticketsClickHandler(rowData.docId) },
                        },
                    ]}
                    onPageChange={ (pageNum) => { sessionStorage.setItem("ticketReportPageValue", JSON.stringify(pageNum)) }}
                    options={{
                        pageSize: "ticketReportRowsPerPage" in sessionStorage ? JSON.parse(sessionStorage.getItem("ticketReportRowsPerPage")) : 25,
                        initialPage: "ticketReportPageValue" in sessionStorage ? JSON.parse(sessionStorage.getItem("ticketReportPageValue")) : 0,
                        toolbar: true,
                        paging: true,
                        columnsButton: true,
                        thirdSortClick: true,
                        searchText: searchBarValue,
                        exportMenu: [
                            {
                                label: "Export Table Data as CSV",
                                exportFunc: (cols) => ExportCsv(cols, tableRef?.current?.state?.data, `TicketReportData`),
                            },
                            {
                                label: "Export Table Data as PDF",
                                exportFunc: (cols) => ExportPdf(cols, tableRef?.current?.state?.data, `TicketReportData`),
                                },
                        ],
                    }}
                />
                : <Skeleton variant='rect' width={'80vw'} height={'160vh'}/>}
                {smallScreen ?
                <div>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}

                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                        >
                        <ExpandMoreIcon style={{fontSize: '50px'}} />
                    </IconButton>
                    <Collapse orientation="horizontal" in={expanded} timeout="auto" unmountOnExit>
                        <Paper className={classes.sidebar}>
                            <ReportSelect
                                reportType={props.reportType}
                                onchange={props.onchange}
                            />
                            <TicketOptions
                                startDate={startDate}
                                startDateHandler={startDateHandler}
                                endDate={endDate}
                                endDateHandler={endDateHandler}
                                generateHandler={generateHandler}
                                errorMsg={errorMessage}
                                loading={loading}
                                users={users}
                                usersLoading={usersLoading}
                                ticketData={props.ticketData}
                                searchUsers={searchUsers}
                                setSearchUsers={setSearchUsers}
                                darkMode={darkMode}
                                handlePrintTicketReport={handlePrintTicketReport}
                            />
                        </Paper>
                    </Collapse>
                </div>
                :
                <Paper className={classes.sidebar}>
                    <ReportSelect
                        reportType={props.reportType}
                        onchange={props.onchange}
                    />
                    <TicketOptions
                        startDate={startDate}
                        startDateHandler={startDateHandler}
                        endDate={endDate}
                        endDateHandler={endDateHandler}
                        generateHandler={generateHandler}
                        errorMsg={errorMessage}
                        loading={loading}
                        users={users}
                        usersLoading={usersLoading}
                        ticketData={props.ticketData}
                        searchUsers={searchUsers}
                        setSearchUsers={setSearchUsers}
                        darkMode={darkMode}
                        handlePrintTicketReport={handlePrintTicketReport}
                    />
                </Paper> }
            </div>
        </React.Fragment>
    )
}

//Map slice of global state to props
const mapStateToProps = (state) => {
    return {
        // state refers to global state/ redux state (acts somewhat like singleton)
        // "products" is the name given in index.js to the state of our reducer
        // the props: featuredProducts and loading come from the reducer productsReducer.js
        //cart: state.cart.cart,
        ticketData: state.tableCache.ticketReport.ticketData,
    };
}

//map our dispatch functions to props
const mapDispatchToProps = dispatch => {
    return {
        updateTableCache: (tableKey, tableValue) => dispatch(actionCreators.updateTableCache(tableKey, tableValue)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketReport));